import React from 'react';
import { Route } from 'react-router-dom';
import { createRoute } from '@core/router';
import hydrasoloDashboardRoute from '@modules/iot/hydrasolo/dashboard/DashboardPage';

const dashBoardRoutes = <Route index {...createRoute(hydrasoloDashboardRoute)} />;

export default dashBoardRoutes;
